angular
  .module('jrSubscription', ['jrGoogleTagManager', 'jrConfig', 'jrUtil'])
  .factory('SubscriptionUrlService', [
    'jrGlobalConfig',
    'JobseekerConfig',
    'SearchDistanceConfig',
    '$filter',
    function (jrGlobalConfig, JobseekerConfig, SearchDistanceConfig, $filter) {
      function baseUrlCreate() {
        return `${jrGlobalConfig.baseUrl}jobseeker/create`;
      }

      function baseUrlUpdate() {
        return `${jrGlobalConfig.baseUrl}jobseeker/update`;
      }

      function baseUrlLogin() {
        return `${jrGlobalConfig.baseUrl}login`;
      }

      function baseUrlRecoverPassword() {
        return `${jrGlobalConfig.baseUrl}recoverpassword`;
      }

      function baseUrlResetPassword() {
        return `${jrGlobalConfig.baseUrl}resetpassword`;
      }

      function baseUrlChangePassword() {
        return `${jrGlobalConfig.baseUrl}changepassword`;
      }

      function baseUrlSetPassword() {
        return `${jrGlobalConfig.baseUrl}setpassword`;
      }

      function payloadCreateNew(
        email,
        search,
        source,
        password,
        confirmPassword,
        referrer,
        firstname,
        lastname,
        captchaUserResponse
      ) {
        const url = [];
        url.push(`w=${$filter('encodeUri')(search.what)}`);
        url.push(`l=${$filter('encodeUri')(search.where)}`);
        url.push(
          `r=${
            SearchDistanceConfig.enabled && !!search.where
              ? $filter('encodeUri')(search.distance.value)
              : ''
          }`
        );
        url.push('ConditionAcceptance=on');
        url.push(`Email=${$filter('encodeUri')(email)}`);
        url.push(`ParentShardId=${JobseekerConfig.parentShardId}`);
        url.push(`ParentUserId=${JobseekerConfig.parentUserId}`);
        url.push('DemAcceptance=true');
        url.push(`s=${source || ''}`);
        url.push(`subscriptionSource=${source || ''}`);
        url.push(`password=${password || ''}`);
        url.push(`referrer=${referrer || ''}`);
        url.push(`firstname=${firstname || ''}`);
        url.push(`lastname=${lastname || ''}`);
        if (captchaUserResponse) {
          url.push(`captchaUserResponse=${captchaUserResponse || ''}`);
        }

        return url.join('&');
      }

      function payloadAddMySearches(email, mySearches) {
        const url = [];

        url.push(`w2=${$filter('encodeUri')(mySearches[0].what)}`);
        url.push(`l2=${$filter('encodeUri')(mySearches[0].where)}`);
        url.push(`w3=${$filter('encodeUri')(mySearches[1].what)}`);
        url.push(`l3=${$filter('encodeUri')(mySearches[1].where)}`);
        url.push(`Email=${$filter('encodeUri')(email)}`);

        return url.join('&');
      }

      function payloadLogin(email, password) {
        const url = [];
        url.push(`login-email=${$filter('encodeUri')(email)}`);
        url.push(`login-password=${password}`);

        return url.join('&');
      }

      function payloadRecoverPassword(email) {
        const url = [];
        url.push(`recover-password-email=${$filter('encodeUri')(email)}`);

        return url.join('&');
      }

      function payloadResetPassword(password, confirmPassword) {
        const url = [];
        url.push(`reset-password=${password || ''}`);
        url.push(`reset-password-confirm=${confirmPassword || ''}`);
        url.push(`token=${getParameterByName('token')}`);

        return url.join('&');
      }

      function payloadChangePassword(password, confirmPassword, oldPassword) {
        const url = [];
        url.push(`change-password=${password || ''}`);
        url.push(`change-password-confirm=${confirmPassword || ''}`);
        url.push(`change-password-old-password=${oldPassword || ''}`);

        return url.join('&');
      }

      function getParameterByName(name) {
        const regex = new RegExp(
          `[\\?&]${name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')}=([^&#]*)`
        );
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }

      return {
        baseUrlCreate,
        baseUrlUpdate,
        baseUrlLogin,
        baseUrlRecoverPassword,
        baseUrlResetPassword,
        baseUrlChangePassword,
        baseUrlSetPassword,
        payloadCreateNew,
        payloadAddMySearches,
        payloadLogin,
        payloadRecoverPassword,
        payloadResetPassword,
        payloadChangePassword,
      };
    },
  ])
  .factory('SubscriptionService', [
    'SubscriptionUrlService',
    'GoogleTagManagerConfig',
    'GoogleTagManagerService',
    'emailFormatterService',
    '$http',
    '$q',
    function (
      SubscriptionUrlService,
      GoogleTagManagerConfig,
      GoogleTagManagerService,
      emailFormatterService,
      $http,
      $q
    ) {
      function subscribe(
        email,
        search,
        source,
        password,
        confirmPassword,
        referrer,
        firstname,
        lastname,
        captchaUserResponse
      ) {
        const payloadCreateUrl = SubscriptionUrlService.payloadCreateNew(
          email,
          search,
          source,
          password,
          confirmPassword,
          referrer,
          firstname,
          lastname,
          captchaUserResponse
        );
        const baseUrl = SubscriptionUrlService.baseUrlCreate();
        const accountCreatePromise = $http({
          method: 'POST',
          url: baseUrl,
          data: payloadCreateUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });

        if (GoogleTagManagerConfig.enabled) {
          const deferred = $q.defer();
          const googleTagManagerEvent = function (result) {
            const created = result.status >= 200 && result.status < 300;
            // track social

            if (source === 'facebook') {
              dataLayer.push({
                event: 'signup.facebook',
                emailDomain: emailFormatterService.getDomain(email),
              });
            }
            if (source === 'google') {
              dataLayer.push({
                event: 'signup.google',
                emailDomain: emailFormatterService.getDomain(email),
              });
            }
            if (source === 'linkedin') {
              dataLayer.push({
                event: 'signup.linkedin',
                emailDomain: emailFormatterService.getDomain(email),
              });
            }
            // Pushing event based on success of the http call
            GoogleTagManagerService.pushEvent('jobseekerCreate', {
              jobseekerCreated: created,
              subscriberUid: result.headers('subscriberUid'),
              subscriptionConversionValue: parseFloat(
                result.headers('subscriptionConversionValue')
              ),
            }).then(function () {
              // Return the original result from subscribing api
              deferred.resolve(result);
            });

            return deferred.promise;
          };

          return accountCreatePromise.then(googleTagManagerEvent, googleTagManagerEvent);
        }
        return accountCreatePromise;
      }

      function addMySearches(email, mySearches) {
        const baseUrl = SubscriptionUrlService.baseUrlUpdate();
        const payloadAddMySearchesUrl = SubscriptionUrlService.payloadAddMySearches(
          email,
          mySearches
        );

        return $http({
          method: 'POST',
          url: baseUrl,
          data: payloadAddMySearchesUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      function login(email, password) {
        const baseUrl = SubscriptionUrlService.baseUrlLogin();
        const payloadLoginUrl = SubscriptionUrlService.payloadLogin(email, password);
        return $http({
          method: 'POST',
          url: baseUrl,
          data: payloadLoginUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      function recoverPassword(email) {
        const baseUrl = SubscriptionUrlService.baseUrlRecoverPassword();
        const payloadRecoverPasswordUrl = SubscriptionUrlService.payloadRecoverPassword(email);
        return $http({
          method: 'POST',
          url: baseUrl,
          data: payloadRecoverPasswordUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      function resetPassword(password, confirmPassword) {
        const baseUrl = SubscriptionUrlService.baseUrlResetPassword();
        const payloadResetPasswordUrl = SubscriptionUrlService.payloadResetPassword(
          password,
          confirmPassword
        );
        return $http({
          method: 'POST',
          url: baseUrl,
          data: payloadResetPasswordUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      function changePassword(password, confirmPassword, oldPassword) {
        const baseUrl = SubscriptionUrlService.baseUrlChangePassword();
        const payloadChangePasswordUrl = SubscriptionUrlService.payloadChangePassword(
          password,
          confirmPassword,
          oldPassword
        );
        return $http({
          method: 'POST',
          url: baseUrl,
          data: payloadChangePasswordUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      function setPassword(password) {
        const baseUrl = SubscriptionUrlService.baseUrlSetPassword();

        return $http({
          method: 'POST',
          url: baseUrl,
          data: `password=${password || ''}`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
      }

      return {
        subscribe,
        addMySearches,
        recoverPassword,
        resetPassword,
        setPassword,
        changePassword,
        login,
      };
    },
  ]);
